var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12V38C8 41.3137 10.6863 44 14 44H34C37.3137 44 40 41.3137 40 38V18C40 14.6863 37.3137 12 34 12H8ZM8 12V10",
    stroke: "#DC143C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12V13H37V12H36ZM31.4343 4.65224L31.2929 3.66229V3.66229L31.4343 4.65224ZM9.83919 7.73725L9.69777 6.7473H9.69777L9.83919 7.73725ZM10.1421 12V13H36V12V11H10.1421V12ZM36 12H37V8.61203H36H35V12H36ZM31.4343 4.65224L31.2929 3.66229L9.69777 6.7473L9.83919 7.73725L9.98061 8.7272L31.5757 5.64219L31.4343 4.65224ZM9.83919 7.73725L9.69777 6.7473C8.1498 6.96844 7 8.29418 7 9.85786H8H9C9 9.28947 9.41794 8.80758 9.98061 8.7272L9.83919 7.73725ZM36 8.61203H37C37 5.56929 34.3051 3.23198 31.2929 3.66229L31.4343 4.65224L31.5757 5.64219C33.383 5.384 35 6.78639 35 8.61203H36ZM10.1421 12V11C9.51135 11 9 10.4886 9 9.85786H8H7C7 11.5932 8.40678 13 10.1421 13V12Z",
    fill: "#DC143C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H32",
    stroke: "#DC143C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31H27",
    stroke: "#DC143C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5dcd3ad9df666efe82f33c3003047196.svg";
export { ForwardRef as ReactComponent };